/**
 * 조건부 className 조합 유틸.
 * - falsy(`false`, `undefined`, `''`) 값은 제거
 * - 문자열/boolean/undefined 만 허용 (객체/배열 불가)
 *
 * @example
 * cn('btn', isActive && 'btn-active', disabled && 'opacity-50')
 * cn('flex', variant === 'primary' ? 'bg-primary' : 'bg-secondary')
 */
export const cn = (...classes: (string | boolean | undefined)[]) => {
  return classes.filter(Boolean).join(' ')
}
